// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/iam/auditlog/auditlog.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_LOGS } from "./action";

export function canListLogs(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_LOGS);
}
